import React from 'react';
import { useHistory } from "react-router";
import './getstarted.styles.scss';
import { Link } from 'react-router-dom';
import TrackedSection from '../google/GoogleAnalytics';
import { useTranslation } from 'react-i18next';

export const Getstarted = () => {
  const history = useHistory();
  const { t } = useTranslation();

  const handleRequestDemo = () => {
    history.push("/request-sales");
    window.scrollTo(0, 0);
  };

  return (
    <TrackedSection sectionName="GetStarted">
      <div className='footer-sec'>
        <p className='get-started text-bold font-weight-bold'>{t('getStarted.title')}</p>
        <p className='earthid-footer-desc'>{t('getStarted.description')}</p>
        <button className='footer-btn_1' onClick={handleRequestDemo}>
          <Link className='links'>
            <p className='btn-title'>{t('getStarted.cta')}</p>
          </Link>
        </button>
      </div>
    </TrackedSection>
  );
};
